import { HISTORY_V2 } from '../../../../config';
import { useNavigate } from "../../../../vendor/router-ROUTER_TARGET";
import { useSelector, useDispatch } from "react-redux";

import { resetNCState } from "../../nav-control/redux/actions/index";
import { historyPrev, historyNext } from "../../../../actions/index";

const useNavTabBar = (action) => {
  const navigate = useNavigate();
  const storeHistory = useSelector(state => state.storeHistory); // V1
  const historyRedux = useSelector(state => state.history);       // V2
  const dispatch = useDispatch();

  const { prev, next } = storeHistory;
  const history = HISTORY_V2 ? historyRedux : storeHistory.history;
  const i = history ? history.findIndex(x => x.active) : -1;

  let active = false;
  let onClick = null;
  switch(action) {
    case 'previous':
      active = (i > 0)
      onClick = () => {
        if (HISTORY_V2) {
          navigate(history[i - 1].path);
          dispatch(historyPrev());
        } else {
          prev(navigate);
        }
        dispatch(resetNCState()); // Nav Control Module
      }
      break;
    case 'next':
      active = (i >= 0 && i < history.length - 1);
      onClick = () => {
        if (HISTORY_V2) {
          navigate(history[i + 1].path);
          dispatch(historyNext());
        } else {
          next(navigate);
        }
        dispatch(resetNCState()); // Nav Control Module
      }
      break;
    default:
  }

  return { active, onClick };
};

export default useNavTabBar;
